export function productCarousel() {
    const section = document.querySelector('.l-section-products');
    if (!section) return;

    const swiperEl = section.querySelector('.swiper-container');
    const nextBtn = section.querySelector('#next-swiper');
    const prevBtn = section.querySelector('#prev-swiper');

    if (!swiperEl) return;

    // Спочатку приховуємо кнопку "назад", оскільки ми завжди починаємо з першого слайда
    prevBtn.style.display = 'none';

    const swiper = new Swiper(swiperEl, {
      // Видаляємо loop: true для коректної роботи навігації
      loop: false,
      slidesPerView: 4,
      spaceBetween: 2,
      slidesOffsetBefore: 5,
      slidesOffsetAfter: 5,
      breakpoints: {
        320:  { slidesPerView: 1, spaceBetween: 2, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
        764:  { slidesPerView: 2, spaceBetween: 2, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
        1024: { slidesPerView: 3, spaceBetween: 2, slidesOffsetBefore: 5, slidesOffsetAfter: 5 },
        1200: { slidesPerView: 4, spaceBetween: 2, slidesOffsetBefore: 5, slidesOffsetAfter: 5 },
      },
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      // Додаємо обробники подій для керування видимістю кнопок
      on: {
        init: function() {
          // На початку перевіряємо чи можемо крутити назад
          updatePrevButton(this);
        },
        slideChange: function() {
          // При зміні слайда перевіряємо чи можемо крутити назад
          updatePrevButton(this);
        }
      }
    });

    // Функція для оновлення видимості кнопки "назад"
    function updatePrevButton(swiper) {
      if (swiper.isBeginning) {
        // Якщо ми на початку слайдера, ховаємо кнопку "назад"
        prevBtn.style.display = 'none';
      } else {
        // Інакше показуємо кнопку
        prevBtn.style.display = '';
      }
    }
  }
